class DiscountPopup {
  constructor(root) {
    this.root = root;
    this.storageKey = 'velixco-discount-popup-dismissed';
    this.delayMs = Number(root.dataset.delaySeconds || 20) * 1000;
    this.closeBtn = root.querySelector('[data-discount-popup-close]');
    this.overlay = root.querySelector('[data-discount-popup-overlay]');
    this.copyBtn = root.querySelector('[data-discount-popup-copy]');
    this.codeEl = root.querySelector('[data-discount-popup-code]');

    this.closeBtn?.addEventListener('click', () => this.hide(true));
    this.overlay?.addEventListener('click', () => this.hide(true));
    this.copyBtn?.addEventListener('click', () => this.copyCode());

    document.addEventListener('keydown', (event) => {
      if (event.code === 'Escape' && this.root.classList.contains('is-open')) {
        this.hide(true);
      }
    });

    if (sessionStorage.getItem(this.storageKey) === '1') return;

    window.setTimeout(() => {
      if (sessionStorage.getItem(this.storageKey) === '1') return;
      this.show();
    }, this.delayMs);
  }

  show() {
    this.root.removeAttribute('hidden');
    requestAnimationFrame(() => {
      this.root.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
      this.closeBtn?.focus();
    });
  }

  hide(remember) {
    this.root.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    if (remember) {
      sessionStorage.setItem(this.storageKey, '1');
    }
    window.setTimeout(() => {
      if (!this.root.classList.contains('is-open')) {
        this.root.setAttribute('hidden', '');
      }
    }, 250);
  }

  async copyCode() {
    const code = this.codeEl?.textContent?.trim();
    if (!code || !this.copyBtn) return;

    try {
      await navigator.clipboard.writeText(code);
      const original = this.copyBtn.textContent;
      this.copyBtn.textContent = this.copyBtn.dataset.copiedLabel || 'Copied';
      this.copyBtn.classList.add('is-copied');
      window.setTimeout(() => {
        this.copyBtn.textContent = original;
        this.copyBtn.classList.remove('is-copied');
      }, 2000);
    } catch (error) {
      const range = document.createRange();
      range.selectNodeContents(this.codeEl);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('VelixcoDiscountPopup');
  if (root) new DiscountPopup(root);
});
